import styled from 'styled-components';

export const TextArea = styled.textarea`
  display: block;
  margin-top: 6px;
  width: 100%;
  height: 117px;
  resize: none;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px;
  padding: 10px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
`;

export const TextAreaCounter = styled.span`
  align-self: flex-end;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;
